import { useMutation } from '@apollo/client';
import CircularProgress from 'components/CircularProgress';
import deviceSizes from 'constants/deviceSizes';
import React, { useState } from 'react';
import TabLayout from 'routes/Users/components/UsersList/UserDetailDrawer/ClientViewTabs/TabLayout';
import { DELETE_USERS_LOCATIONS, UPDATE_CREATE_USERS_LOCATION } from 'services/graphql/mutations/location';
import { LocationRole } from 'types/location';
import { defaultNotification } from 'utils';

import { useLocationFormProps } from '../../LocationForm/hooks';
import LocationFormUserAssign from '../../LocationForm/LocationFormUserAssign';
import { ILocationTabDetailProps } from '../types';

const LocationUserAssign: React.FC<ILocationTabDetailProps> = ({ location, refetchLocationData }) => {
  const [inputValues, setInputValues] = useState<Record<string, any>>({});

  const { users, firstLoading, onUserAssignFormLocationSearch, selectedUsers } = useLocationFormProps();

  const [createUpdateUsersLocations, { loading: submitLoading }] = useMutation(UPDATE_CREATE_USERS_LOCATION);
  const [deleteUsersLocations] = useMutation(DELETE_USERS_LOCATIONS);

  const callUpdateUsersLocation = async (filters: any[], updatedDocs: any[]) => {
    try {
      await createUpdateUsersLocations({
        variables: {
          filters,
          updatedDocs,
        },
      });
      defaultNotification({ success: 'Assign Location Role successfully!' });
      refetchLocationData?.();
    } catch (err) {
      console.log(err);
      defaultNotification({ failure: true });
    }
  };

  const callDeleteUsersLocationsMutation = async (ids: string[]) => {
    try {
      await deleteUsersLocations({
        variables: {
          ids,
        },
      });
      refetchLocationData?.();
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = () => {
    const originUsersLocationsWithUserIds =
      location?.usersLocations?.reduce((acc, uL) => {
        if (uL.id && uL.user?.id) acc[uL.user.id] = uL.id;
        return acc;
      }, {} as Record<string, string>) || {};

    const filters: { user: string; location: string }[] = [];
    const updatedDocs = Object.entries(inputValues).map(([userId, locationRole]) => {
      filters.push({ user: userId, location: location.id });
      // delete the key-value pair that has user id in inputValues;
      delete originUsersLocationsWithUserIds[userId];
      return {
        manageUsersPermission: locationRole === LocationRole.LOCATION_ADMIN,
        manageLocationsPermission: false,
        clientPermission: locationRole === LocationRole.EMPLOYEE || locationRole === LocationRole.LOCATION_ADMIN,
      };
    });

    callUpdateUsersLocation(filters, updatedDocs);
    const deletedUsersLocationsIds = Object.values(originUsersLocationsWithUserIds);
    console.log('delete', deletedUsersLocationsIds, originUsersLocationsWithUserIds, location?.usersLocations);

    if ((deletedUsersLocationsIds?.length || 0) > 0) callDeleteUsersLocationsMutation(deletedUsersLocationsIds);
  };

  return (
    <TabLayout loading={submitLoading} onClick={onSubmit}>
      {firstLoading ? (
        <CircularProgress />
      ) : (
        <div className='border-b h-full border-border_color'>
          <LocationFormUserAssign
            selectedUsers={selectedUsers}
            minimizeThreshold={deviceSizes.numbers.xxl}
            style={{ height: '100%' }}
            users={users}
            location={location}
            inputValues={inputValues}
            setInputValues={setInputValues}
            onRightColumnSearch={onUserAssignFormLocationSearch}
            userFetchLoading={firstLoading}
          />
        </div>
      )}
    </TabLayout>
  );
};

export default React.memo(LocationUserAssign);
